import React, { useState, useEffect } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import * as XLSX from "xlsx";
import { useLoading } from "../Utils/LoadingContext";
import CustomDataTable from "../components/CustomDataTable";

const AttendancePunchReport = () => {
  const empcode = localStorage.getItem("empcode");
  const [data, setData] = useState([]);
  const { setLoading } = useLoading();
  const [plants, setPlants] = useState([]);

  // 🔹 Toggles for filters and table
  const [showFilters, setShowFilters] = useState(true);
  const [showTable, setShowTable] = useState(true);

  const [filters, setFilters] = useState({
    MonthYear: "",
    PlantName: "",
    EmployeeCode: "",
  });

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {
      const plantRes = await EmployeeProcessService.getPlant(empcode);
      if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result);
    } catch (error) {
      console.error("Error loading dropdowns:", error);
    }
  };

  // ✅ Generate last 12 months for dropdown
  const getMonthYearOptions = () => {
    const options = [];
    const today = new Date();
    for (let i = 0; i < 12; i++) {
      const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      options.push(`${date.getFullYear()}-${month}`);
    }
    return options;
  };

  const monthYearOptions = getMonthYearOptions();

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await EmployeeProcessService.getAttendancePunch(filters);
      if (response.data.statusCode === 200 && response.data.result.length > 0) {
        setData(response.data.result);
      } else {
        setData([]);
        alert("No records found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      alert("No records found");
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    if (!filters.MonthYear) {
      alert("Please select Month-Year");
      return;
    }
    if (!filters.PlantName) {
      alert("Please select Plant.");
      return;
    }
    fetchData();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const downloadXLSX = () => {
    const worksheetData = data.map((emp) => ({
      EmployeeCode: emp.employeeCode,
      EmployeeName: emp.employeeName,
      PlantName: emp.plantName,
      VenderName: emp.venderName,
      DepartmentName: emp.departmentName,
      PunchDate: emp.punchDate,
      ShiftName: emp.shiftName,
      FirstPunchIn: emp.firstPunchIn,
      LastPunchOut: emp.lastPunchOut,
      TotalMinutes: emp.totalMinutes,
      Status: emp.status,
      DayType: emp.dayType,
      Incentive: emp.incentive,
      LateMinutes: emp.lateMinutes,
      CumLateMinutes: emp.cumLateMinutes
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
    XLSX.writeFile(workbook, "AttendanceMonthWise.xlsx");
  };

  return (
    <div className="container mt-2">

      {/* 🔹 Heading */}
      <div className="mb-2 p-2 bg-light rounded">
        <h6 className="m-0 text-primary">Attendance Month Wise Report</h6>
      </div>

      {/* 🔹 Filters Section */}
      <div
        className="d-flex justify-content-between align-items-center mb-2 p-2 bg-secondary bg-opacity-10 rounded"
        style={{ cursor: "pointer" }}
        onClick={() => setShowFilters(!showFilters)}
      >
        <h6 className="m-0">Filters</h6>
        <span style={{ fontSize: "13px" }}>{showFilters ? "▲" : "▼"}</span>
      </div>

      {showFilters && (
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label fw-bold text-info">Select Month-Year</label>
            <select
              name="MonthYear"
              value={filters.MonthYear}
              onChange={handleChange}
              className="form-select"
            >
              <option value="">Select Month-Year</option>
              {monthYearOptions.map((my) => (
                <option key={my} value={my}>
                  {my}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label fw-bold text-info">Select Plant</label>
            <select
              name="PlantName"
              value={filters.PlantName}
              onChange={handleChange}
              className="form-select"
            >
              <option value="">Select Plant</option>
              {plants.map((plan) => (
                <option key={plan.id} value={plan.id}>
                  {plan.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label fw-bold text-info">Employee Code</label>
            <input
              name="EmployeeCode"
              value={filters.EmployeeCode}
              className="form-control"
              onChange={handleChange}
            />
          </div>

          <div className="col-md-3 d-flex align-items-end">
            <button className="btn btn-primary me-2" onClick={applyFilters}>
              Search
            </button>
            {data.length > 0 && (
              <button className="btn btn-success" onClick={downloadXLSX}>
                Download Excel
              </button>
            )}
          </div>
        </div>
      )}

      {/* 🔹 Table Section */}
      <div
        className="d-flex justify-content-between align-items-center mb-2 p-2 bg-secondary bg-opacity-10 rounded"
        style={{ cursor: "pointer" }}
        onClick={() => setShowTable(!showTable)}
      >
        <h6 className="m-0">Data</h6>
        <span style={{ fontSize: "13px" }}>{showTable ? "▲" : "▼"}</span>
      </div>

      {showTable && (
        <div className="table-responsive">
          <CustomDataTable data={data} title="Employee List" />
        </div>
      )}
    </div>
  );
};

export default AttendancePunchReport;
